import { BirdMark } from "@/components/Logo";

export default function PageIntro({ eyebrow, title, text, testId }) {
  return (
    <section className="safe-x max-w-7xl mx-auto pt-16 pb-10 lg:pt-24 lg:pb-14" data-testid={testId}>
      <div className="max-w-3xl fade-in">
        <p className="eyebrow mb-5">{eyebrow}</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] text-forest">{title}</h1>
        {text && <p className="mt-6 text-base sm:text-lg leading-relaxed text-ink-muted max-w-2xl">{text}</p>}
        <BirdMark className="mt-10" />
      </div>
    </section>
  );
}
